import {useAreaUnit} from '@src/hooks/useAreaUnit.ts';
import formatArea from '@src/utils/formatArea.ts';

type AreaIndicatorProps = {
  // The value in square meters
  squareMeters: number;

  // The unit to display the area in. This should generally be left
  // blank so that it uses the user's preference
  unit?: string;
};

const AreaIndicator = ({squareMeters, unit = ''}: AreaIndicatorProps) => {
  const settingsUnit = useAreaUnit();
  const displayUnit = unit || settingsUnit;

  return formatArea(squareMeters, displayUnit);
};

export default AreaIndicator;
